const MANUFACTURER_LOGOS = {
  1: 'partner_logos/1.png',
  10: 'partner_logos/10.png',
  11: 'partner_logos/11.png',
  12: 'partner_logos/12.png',
  1201: 'partner_logos/1201.png',
  124: 'partner_logos/124.png',
  13: 'partner_logos/13.png',
  14: 'partner_logos/14.png',
  15: 'partner_logos/15.png',
  157: 'partner_logos/157.png',
  16: 'partner_logos/16.png',
  17: 'partner_logos/17.png',
  1745: 'partner_logos/1745.png',
  1749: 'partner_logos/1749.png',
  1756: 'partner_logos/1756.png',
  1759: 'partner_logos/1759.png',
  18: 'partner_logos/18.png',
  190: 'partner_logos/190.png',
  2: 'partner_logos/2.png',
  225: 'partner_logos/225.png',
  258: 'partner_logos/258.png',
  291: 'partner_logos/291.png',
  293: 'partner_logos/293.png',
  294: 'partner_logos/294.png',
  296: 'partner_logos/296.png',
  299: 'partner_logos/299.png',
  3: 'partner_logos/3.png',
  325: 'partner_logos/325.png',
  371: 'partner_logos/371.png',
  389: 'partner_logos/389.png',
  396: 'partner_logos/396.png',
  4: 'partner_logos/4.png',
  422: 'partner_logos/422.png',
  424: 'partner_logos/424.png',
  425: 'partner_logos/425.png',
  5: 'partner_logos/5.png',
  50: 'partner_logos/50.png',
  51: 'partner_logos/51.png',
  52: 'partner_logos/52.png',
  53: 'partner_logos/53.png',
  54: 'partner_logos/54.png',
  55: 'partner_logos/55.png',
  56: 'partner_logos/56.png',
  57: 'partner_logos/57.png',
  58: 'partner_logos/58.png',
  59: 'partner_logos/59.png',
  6: 'partner_logos/6.png',
  7: 'partner_logos/7.png',
  8: 'partner_logos/8.png',
  9: 'partner_logos/9.png',
  91: 'partner_logos/91.png',
  5839: 'partner_logos/5839.png',
  8485: 'partner_logos/8485.png',
  8502: 'partner_logos/8502.png',
  8532: 'partner_logos/8532.png',
  8514: 'partner_logos/8514.png',
  8705: 'partner_logos/8705.png',
  8756: 'partner_logos/8756.png',
  8806: 'partner_logos/8806.png',
  8807: 'partner_logos/8807.png',
  9548: 'partner_logos/9548.png',
  9566: 'partner_logos/9566.png',
  9871: 'partner_logos/9871.png',
  9944: 'partner_logos/9944.png',
  10153: 'partner_logos/10153.png',
  10181: 'partner_logos/10181.png',
  10293: 'partner_logos/10293.png',
};

const MANUFACTURER_LOGOS_SMALL = {
  1: 'partner_logos/1-sq.png',
  10: 'partner_logos/10-sq.png',
  11: 'partner_logos/11-sq.png',
  12: 'partner_logos/12-sq.png',
  1201: 'partner_logos/1201-sq.png',
  124: 'partner_logos/124-sq.png',
  13: 'partner_logos/13-sq.png',
  14: 'partner_logos/14-sq.png',
  15: 'partner_logos/15-sq.png',
  157: 'partner_logos/157-sq.png',
  16: 'partner_logos/16-sq.png',
  17: 'partner_logos/17-sq.png',
  1745: 'partner_logos/1745-sq.png',
  1749: 'partner_logos/1749-sq.png',
  1756: 'partner_logos/1756-sq.png',
  1759: 'partner_logos/1759-sq.png',
  18: 'partner_logos/18-sq.png',
  190: 'partner_logos/190-sq.png',
  2: 'partner_logos/2-sq.png',
  225: 'partner_logos/225-sq.png',
  258: 'partner_logos/258-sq.png',
  291: 'partner_logos/291-sq.png',
  293: 'partner_logos/293-sq.png',
  294: 'partner_logos/294-sq.png',
  296: 'partner_logos/296-sq.png',
  299: 'partner_logos/299-sq.png',
  3: 'partner_logos/3-sq.png',
  325: 'partner_logos/325-sq.png',
  371: 'partner_logos/371-sq.png',
  389: 'partner_logos/389-sq.png',
  396: 'partner_logos/396-sq.png',
  4: 'partner_logos/4-sq.png',
  422: 'partner_logos/422-sq.png',
  424: 'partner_logos/424-sq.png',
  425: 'partner_logos/425-sq.png',
  5: 'partner_logos/5-sq.png',
  50: 'partner_logos/50-sq.png',
  51: 'partner_logos/51-sq.png',
  52: 'partner_logos/52-sq.png',
  53: 'partner_logos/53-sq.png',
  54: 'partner_logos/54-sq.png',
  55: 'partner_logos/55-sq.png',
  56: 'partner_logos/56-sq.png',
  57: 'partner_logos/57-sq.png',
  58: 'partner_logos/58-sq.png',
  59: 'partner_logos/59-sq.png',
  6: 'partner_logos/6-sq.png',
  7: 'partner_logos/7-sq.png',
  8: 'partner_logos/8-sq.png',
  9: 'partner_logos/9-sq.png',
  91: 'partner_logos/91-sq.png',
  5839: 'partner_logos/5839-sq.png',
  8485: 'partner_logos/8485-sq.png',
  8502: 'partner_logos/8502-sq.png',
  8532: 'partner_logos/8532-sq.png',
  8514: 'partner_logos/8514-sq.png',
  8705: 'partner_logos/8705-sq.png',
  8756: 'partner_logos/8756-sq.png',
  8806: 'partner_logos/8806-sq.png',
  8807: 'partner_logos/8807-sq.png',
  9548: 'partner_logos/9548-sq.png',
  9566: 'partner_logos/9566-sq.png',
  9871: 'partner_logos/9871-sq.png',
  9944: 'partner_logos/9944-sq.png',
  10153: 'partner_logos/10153-sq.png',
  10181: 'partner_logos/10181-sq.png',
  10293: 'partner_logos/10293-sq.png',
};

const MANUFACTURERS_WITH_LOGOS = Object.keys(MANUFACTURER_LOGOS).map(Number);
const LOGO_WIDTH = 192;
const LOGO_HEIGHT = 70;

export default {
  LOGO_HEIGHT,
  LOGO_WIDTH,
  MANUFACTURERS_WITH_LOGOS,
  MANUFACTURER_LOGOS,
  MANUFACTURER_LOGOS_SMALL,
};
